// Strips < > { } [ ] from input to block HTML/code snippets. `=` is kept (URLs need it).
export const stripHtmlBrackets = (value = "") => value.replace(/[<>{}[\]]/g, "");
